import store from '@/store'

const AppView = () => import('../../views/AppLayout')

const beforeEnter = (to, from, next) => {
  const user = store.getters.getUser;
  const agent = store.getters.getAgent;

  if (!hasAccessToMailCenter(user, agent)) {
    next(from.fullPath)
  } else {
    next();
  }
}

const hasAccessToMailCenter = (user, agent) => {
  if (!user || !agent) return false;
  if (Object.keys(user).length === 0) return false;
  if (user.roles.includes('ROLE_ADMIN')) return true;
  if (agent && agent.mail && user.roles.includes('ROLE_AGENT')) return true;
  return false;
}

export default [
  {
    name: "Mail Center",
    path: "/tickets",
    meta: {
      isInMenu: true,
      title: 'main-menu.tickets.title',
      icon: 'fas fa-inbox',
      type: 'title',
      order: 7,
      custom_access_control: hasAccessToMailCenter,
      access_control: ['ROLE_AGENT'],
      beforeEnter: beforeEnter
    },
    components: {
      appView: AppView
    },
    children: [
      {
        name: "TicketNew",
        path: "/tickets/new",
        component: () => import('../../views/mail-center/TheNewTicket'),
        meta: {
          requiresAuth: true,
          isInMenu: true,
          title: 'main-menu.tickets.create-new-ticket',
          custom_access_control: hasAccessToMailCenter,
          access_control: ['ROLE_AGENT'],
        },
        beforeEnter
      },
      {
        name: "TicketsAssignedToMe",
        path: "/tickets",
        meta: {
          title: 'tickets.tickets',
          requiresAuth: true,
          isInMenu: true,
          custom_access_control: hasAccessToMailCenter,
          access_control: ['ROLE_AGENT'],
          query: {
            status: 'open'
          }
        },
        components: {
          default: () => import('../../views/mail-center/TheMainMailCenter')
        },
        beforeEnter
      },
      {
        name: "ticket",
        path: "/ticket/:ticketNumber",
        meta: {
          requiresAuth: true,
          custom_access_control: hasAccessToMailCenter,
          access_control: ['ROLE_AGENT'],
        },
        components: {
          default: () => import('../../views/mail-center/TheTicket')
        },
        props: {
          default: true
        },
        beforeEnter
      },
      {
        name: "mailcenter.newUser",
        path: "/mail-center/users/new",
        meta: {
          requiresAuth: true,
          custom_access_control: hasAccessToMailCenter,
          access_control: ['ROLE_AGENT'],
        },
        components: {
          default: () => import('../../views/mail-center/TheUserNew')
        }
      },
      {
        name: "mailcenter.usersList",
        path: "/mail-center/:tab",
        meta: {
          isInMenu: true,
          requiresAuth: true,
          title: 'main-menu.tickets.admin',
          custom_access_control: hasAccessToMailCenter,
          access_control: ['ROLE_AGENT'],
        },
        components: {
          default: () => import('../../views/mail-center/TheMainMailCenterCrud')
        },
        props: {
          default: true,
          tab: 'users'
        },
        beforeEnter
      },
      {
        name: "mailcenter.editUser",
        path: "/mail-center/users/:id",
        meta: {
          requiresAuth: true,
          custom_access_control: hasAccessToMailCenter,
          access_control: ['ROLE_AGENT'],
        },
        components: {
          default: () => import('../../views/mail-center/TheUserEdit')
        },
        props: {
          default: true,
          user: null,
        },
        beforeEnter
      },
      {
        name: "mailcenter.organizationList",
        path: "/mail-center/:tab",
        meta: {
          requiresAuth: true,
          access_control: ['ROLE_ADMIN'],
        },
        components: {
          default: () => import('../../views/mail-center/TheMainMailCenterCrud')
        },
        props: {
          default: true,
          tab: 'organizations'
        },
      },
      {
        name: "mailcenter.newOrganization",
        path: "/mail-center/organizations/new",
        meta: {
          requiresAuth: true,
          access_control: ['ROLE_ADMIN'],
        },
        components: {
          default: () => import('../../views/mail-center/TheOrganizationNew')
        }
      },
      {
        name: "mailcenter.organizationEdit",
        path: "/mail-center/organizations/:id",
        meta: {
          requiresAuth: true,
          access_control: ['ROLE_ADMIN'],
        },
        components: {
          default: () => import('../../views/mail-center/TheOrganizationEdit')
        },
        props: {
          default: true,
          organzation: null,
        },
      },
    ]
  }
]
